import { useQuery } from '@abyss/web/hooks/useQuery';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import { GetCountryStates } from './GetCountryStatesSearch.gql';

export const useCountryStatesSearch = (options) => {
  return useQuery(GetCountryStates, {
    ...options,
    url: ApiUrl.graphQl(),
    accessor: 'countryStates',
  });
};
